<template>
  <v-container fluid mb-12 mt-5 style="width: 90%">
    <v-row>
      <v-col sm="3" md="6" offset-lg="0">
        <h1>Offices</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <div class="v-row">
      <v-col cols="6">
        <v-btn-toggle
          v-model="tableDisplay"
          tile
          color="deep-purple accent-3"
          group
          class="text-center"
          rounded
          mandatory
        >
          <v-btn value="offices">
            Offices
          </v-btn>
          <v-btn value="groups">
            Office Groups
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </div>
    <OfficesList :tableDisplay="tableDisplay" :search="search" />
    <OfficeGroups :tableDisplay="tableDisplay" :search="search" />
  </v-container>
</template>

<script>
import OfficesList from '../../components/offices/Offices';
import OfficeGroups from '../../components/offices/OfficeGroups';

export default {
  name: "Offices",
  components: {
    OfficeGroups,
    OfficesList
  },
  data() {
    return {
      search: "",
      tableDisplay: 'offices',
    };
  }
};
</script>